import AddressIcon from '@mui/icons-material/BookOutlined';
import AddressList from './AddressList';

export * from './queries';

export default {
    list: AddressList,
    icon: AddressIcon,
};
